import { useEffect } from 'react';
import Navigation from '../../home/components/Navigation';
import Footer from '../../home/components/Footer';
import CTA from '../../home/components/CTA';
import { useSEO, getServiceSchema } from '../../../utils/seo';

export default function GoogleAdsPage() {
  useSEO({
    title: 'Google Ads for Contractors | LSA & PPC Management Services',
    description: 'Expert Google Local Service Ads and PPC management for contractors. Maximize ROI with professionally managed campaigns. Get your business in front of ready-to-buy customers at the perfect moment.',
    keywords: 'contractor Google Ads, Google Local Service Ads, contractor PPC, Google LSA for contractors, contractor pay per click',
    canonical: '/services/google-ads',
    schema: getServiceSchema(
      'Google Ads Management for Contractors',
      'Maximize your ROI with expertly managed Google Local Service Ads and Pay-Per-Click campaigns. Get your business in front of ready-to-buy customers at the perfect moment.'
    )
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToContact = () => {
    window.location.href = '/#contact';
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-black via-gray-900 to-black overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-red-600/10 via-transparent to-transparent"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-red-600 rounded-2xl mb-6">
              <i className="ri-google-line text-4xl text-white"></i>
            </div>
            <h1 className="font-heading text-5xl md:text-6xl font-bold text-white mb-6">
              Google LSA + PPC
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Maximize your ROI with expertly managed Google Local Service Ads and Pay-Per-Click campaigns. Get your business in front of ready-to-buy customers at the perfect moment.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <button onClick={scrollToContact} className="inline-flex items-center px-8 py-4 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-all whitespace-nowrap cursor-pointer">
                Get Started <i className="ri-arrow-right-line ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: 'ri-shield-check-line', title: 'LSA Setup', desc: 'Get Google Guaranteed badge and top placement' },
              { icon: 'ri-funds-line', title: 'PPC Optimization', desc: 'Maximize ROI with expert campaign management' },
              { icon: 'ri-auction-line', title: 'Bid Management', desc: 'Strategic bidding to win at the lowest cost' },
              { icon: 'ri-pie-chart-line', title: 'Conversion Tracking', desc: 'Measure every lead and optimize performance' }
            ].map((item, index) => (
              <div key={index} className="bg-gray-50 p-8 rounded-2xl hover:shadow-xl transition-all">
                <div className="w-14 h-14 bg-red-100 rounded-xl flex items-center justify-center mb-6">
                  <i className={`${item.icon} text-2xl text-red-600`}></i>
                </div>
                <h3 className="font-heading text-xl font-bold text-black mb-3">{item.title}</h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTA />
      <Footer />
    </div>
  );
}
